import api from './authService'

export interface ProductIntelligenceData {
  status: 'none' | 'pending' | 'processing' | 'completed' | 'failed'
  progress?: number
  activity?: string
  lastRunAt: string | null
  swot: any | null
  marketTrends: any | null
  competitors: any[] | null
  roadmap: any | null
  revenueProjection: any | null
  investorReadiness: any | null
  startupViability: any | null
}

export const productIntelligenceService = {
  async analyze(projectId: string) {
    const response = await api.post(`/product-intelligence/analyze`, { project_id: projectId })
    return response.data
  },

  async getOverview(projectId: string): Promise<{ success: boolean; data: ProductIntelligenceData }> {
    const response = await api.get(`/product-intelligence/${projectId}`)
    return response.data
  },

  async getPitchDeck(projectId: string) {
    const response = await api.get(`/product-intelligence/pitchdeck/${projectId}`)
    return response.data
  },

  async cancelAnalysis(projectId: string) {
    const response = await api.post(`/product-intelligence/cancel/${projectId}`)
    return response.data
  }
}
